import { render, staticRenderFns } from "./OrderBonusSection.vue?vue&type=template&id=375c2a88&"
import script from "./OrderBonusSection.vue?vue&type=script&lang=js&"
export * from "./OrderBonusSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports